/* Compatibility for app requests which omit the storefront locale. */
(() => {
  'use strict';
  const configuredRoot = document.querySelector('script[data-storefront-root]')?.dataset.storefrontRoot || '/';
  const root = `${configuredRoot.replace(/\/$/, '')}/`;
  if (root === '/' || typeof window.fetch !== 'function') return;

  const originalFetch = window.fetch;
  const productIds = () => {
    const ids = new Map();
    document.querySelectorAll(
      'script[data-product-json], script[data-product-card-discount-data], script[data-mib-wishlist-product]'
    ).forEach(script => {
      try {
        const data = JSON.parse(script.textContent);
        const product = data.product || data;
        const id = product.productId || product.id;
        if (product.handle && /^\d+$/.test(String(id))) ids.set(product.handle, String(id));
      } catch { /* Other app payloads do not provide a product identity. */ }
    });
    return ids;
  };

  window.fetch = function storefrontAppFetch(input, options) {
    const isRequest = input instanceof Request;
    const method = options?.method || (isRequest ? input.method : 'GET');
    if (String(method).toUpperCase() !== 'GET') return originalFetch.call(this, input, options);
    let url;
    try {
      url = new URL(isRequest ? input.url : input, location.href);
    } catch {
      return originalFetch.call(this, input, options);
    }
    if (url.origin !== location.origin) return originalFetch.call(this, input, options);

    let changed = false;
    if (/^\/products\/[^/]+\.js$/.test(url.pathname)) {
      // MiB fetches a localized handle through the default-language endpoint.
      url.pathname = root + url.pathname.slice(1);
      changed = true;
    } else if (url.pathname === '/search.js' && url.searchParams.get('app') === 'deco-labels') {
      // Shopify handle search matches canonical handles. IDs survive translation.
      const ids = productIds();
      const query = url.searchParams.get('q') || '';
      url.searchParams.set('q', query.replace(/handle:"([^"\\]+)"/g, (term, handle) => {
        const id = ids.get(handle);
        return id ? `id:${id}` : term;
      }));
      url.pathname = root + 'search.js';
      changed = true;
    }
    if (!changed) return originalFetch.call(this, input, options);
    const localizedInput = isRequest ? new Request(url.href, input) : url.href;
    return originalFetch.call(this, localizedInput, options);
  };
})();
